<template>
  <span><slot /></span>
</template>

<script>
export default { name: 'BaseSpan' }
</script>

<style></style>
